module.exports = __webpack_public_path__ + "static/media/CERTIFICATE-KELAS-PINTAR-Peserta.7f9acacf.png";